module.exports = __webpack_public_path__ + "img/pdf_download.1e8deaa7.svg";